










































import { defineComponent, PropType, ref } from '@vue/composition-api'

// components
import vSelect from 'vue-select'

// models
import { PropOptionSelect } from '@/models'

export default defineComponent({
  name: 'Select2',
  components: {
    vSelect
  },
  props: {
    options: {
      type: Array as PropType<PropOptionSelect[]>,
      required: true
    },
    label: {
      type: String as PropType<string>,
      default: ''
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    placeholder: {
      type: String as PropType<string>,
      default: 'Seleccione una Opción'
    },
    id: {
      type: String as PropType<string>,
      default: ''
    },
    name: {
      type: String as PropType<string>,
      default: ''
    },
    inputClass: {
      type: String as PropType<string>,
      default: ''
    },
    iconClass: {
      type: String as PropType<string>,
      default: ''
    },
    value: {
      type: [String, Number, Array] as PropType<string|number|[]>,
      default: ''
    },
    msgError: {
      type: String as PropType<string>,
      default: ''
    },
    hasError: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    reduce: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    taggable: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    textEmpty: {
      type: String,
      default: 'Sin resultados.'
    }
  },
  setup (props, { emit }) {
    const v_selct_2 = ref(null)

    const optionSelected = () => {
      if (!props.closeOnSelect) {
        setTimeout(() => {
          // @ts-ignore
          v_selct_2.value.open = false
        }, 100)
      }
    }

    const handleChange = (value: string|object|number|null) => {
      emit('input', value)
      emit('change', value)
    }

    return {
      optionSelected,
      v_selct_2,
      handleChange
    }
  }
})
